// Dialog's page types.
export const PAGE_INTRO = 'intro';
export const PAGE_PURPOSES = 'purposes';
export const PAGE_VENDORS = 'vendors';
// Dialog's public custom events.
export const DIALOG_OPENED = 'scmp_opened';
export const DIALOG_CLOSED = 'scmp_closed';
export const DIALOG_EXITED = 'scmp_exited';
export const DIALOG_FAILED = 'scmp_failed';
export const COOKIE_SET = 'scmp_cookie_set';
// Checkbox AB testing.
export const VARIANT = 'J';
// User types
export const USER_INT = 'Int';
export const USER_EXT = 'Ext';
// Urls.
export const VENDORS_URL = 'https://vendorlist.consensu.org/vendorlist.json';
export const SSP_SYNC_URL = 'https://ssp.imedia.cz/static/html/cmp.html';
// Cookie which is older than this date is invalid.
export const CMP_DATE = '2019-08-07T00:00:00';
// Purposes.
export const PURPOSE_CONTENT = 'souhlas_doporucovani';
export const PURPOSE_ADS = 'souhlas_personalizovani';
// Purposes ids.
export const PURPOSE_ID_STORAGE = 1;
export const PURPOSE_ID_PERSONAL = 2;
export const PURPOSE_ID_ADS = 3;
export const PURPOSE_ID_CONTENT = 4;
export const PURPOSE_ID_MEASUREMENT = 5;
// Features ids.
export const FEATURE_ID_OFFLINE = 1;
export const FEATURE_ID_LINKING = 2;
export const FEATURE_ID_GEO = 3;
// Randoms.
export const DEFAULT_LANGUAGE = 'cs';
export const MISSING_CONSENT = false;
export const PRESENT_CONSENT = true;
export const CMP_ID = 247;
export const CMP_VERSION = 1;
export const SEZNAM_VENDOR_ID = 621;
export const NUMBER_OF_VENDORS = 50;

//PAWS Link URLS
export const LOGGED_USER_PAWLINK = 'https://o.seznam.cz/ochrana-udaju/personalizace-obsahu-a-reklamy?lu=1';
export const UNLOGGED_USER_PAWLINK = 'https://o.seznam.cz/ochrana-udaju/personalizace-obsahu-a-reklamy?lu=2 ';
export const CSS_PAW_SELECTOR = 'div.packa > a[href="https://o.seznam.cz/ochrana-udaju/personalizovana-reklama/"]';

// Unlogged user testing domain
export const UNLOGGED_USER_BLACKLIST_DOMAIN = ['profil.seznam.cz', 'login.szn.cz', 'email.seznam.cz'];
export const SZN_SETTING_PAGES = ['o.seznam.cz', 'partner.seznam.cz'];
export const CMP_SSP_IFRAME_URL = 'https://ssp.imedia.cz';

// Redirect
export const EUCONSENT_PARAM_NAME = 'euconsent';
export const SID_COOKIE_NAME = 'sid';

// Time in MS
export const INTERVAL_24 = 86400000; // 24 hodin

// Cookie names
export const LASTSHOW_COOKIE_NAME = 'cmplastshowcookie';
export const LASTSHOW_IMAGINARY_NAME = 'cmpwtf';
export const TEST_COOKIE_NAME = 'cmptestcookie';
export const TESTPERSIST_COOKIE_NAME = 'cmppersisttestcookie';
export const PROFILERROR_COOKIE_NAME = 'cmpprofilerrorcookie';
export const CONSENT_COOKIE_NAME = window._scmpType && window._scmpType === 'test' ? 'TEST_euconsent' : 'euconsent';
export const CONSENT_COOKIE_V2_NAME = 'euconsent-v2';
export const SERVERSIDE_REFRESHER_COOKIE = 'szncsr';

// Sentry
export const SENTRY_DSN = 'https://6197bdb36d274a9b8304f1ecddb49a68@sentry.sklik.cz/64';

// Cypress
export const INTERNAL = 'internal';
export const EXTERNAL = 'external';
export const TESTPERSIST_SHOW_ENABLED = '1572562800000';
export const FOREIGN_VALID_EUCONSENT = 'BOrrFtjOrrFtjEhABBAAABAAAAAAEA';
// eslint-disable-next-line max-len
export const SEZNAM_VALID_EUCONSENT =
  'BOrDL07OrDL07D3ABCCSCx6AAAAs5AIIVEgKQoQI1JBBBgAAAC6IAACAAAQAAABAAAAAIAAACAAgAAAAAEAIAgAAICBABAAAAAAQgAAAAAAAAAAAAAAAAAAAAABCAAAIAAAAQAAAAAAAAAAAAAAAAA';
